import useListItem from "@molecules/ListItem/ListItem.context"

import styles from "./ListItemBottom.module.scss"
import { ListItemBottomProps } from "./ListItemBottom.types"

/** Full-width slot below the body for mobile layouts, where a control that would sit in the actions moves. */
export default function ListItemBottom(props: ListItemBottomProps) {
    const { children } = props

    const { isLoading } = useListItem()

    if (isLoading) {
        return null
    } else {
        return <div className={styles.base}>{children}</div>
    }
}
